/**
 * 
 * CART INITIALIZATION
 * 
 */

let client = null
function runWhenInit() {
  console.log("The current cart state is: ", window.liquidAjaxCart.cart);

  const checkMissingImages = () => {
    
    $('.my-cart__item__image').each(function(){
      // check for missing images
      console.log('missing images')
      if($(this).attr('src')==''){
        window.liquidAjaxCart.update()
        //break loop
        return false;
      }
    })
  }
  console.log("running cart")
  $(".cart-button,.my-cart__close svg,.my-cart__overlay").on("click", function(e){
    // e.preventDefault()
    // document.body.classList.toggle("js-show-ajax-cart");
    // checkMissingImages()
  });

  $searchParams = new URLSearchParams(window.location.search)
  if($searchParams.get("cart")=="show"){
    document.body.classList.toggle("js-show-ajax-cart");
    setTimeout(function(){
      checkMissingImages()
    },1500)
  }

  
  liquidAjaxCart.conf("updateOnWindowFocus", false);
  liquidAjaxCart.conf("quantityTagDebounce", 1000);

  // client = ShopifyStorefrontAPIClient.createStorefrontApiClient({
  //   storeDomain: 'http://rak-staging.myshopify.com',
  //   apiVersion: '2025-01',
  //   publicAccessToken: 'a36379746c76cb96231c4c6a16a09285',
  // });

}

if (window.liquidAjaxCart?.init) {
  // if Liquid Ajax Cart is already initialized
  runWhenInit();
} else {
  // wait for Liquid Ajax Cart to be initialized
  document.addEventListener("liquid-ajax-cart:init", runWhenInit);
}




/**
 * 
 * CART REQUESTS
 * 
 */

let checkedLimits=false


document.addEventListener('liquid-ajax-cart:request-end', event => {
  const {requestState} = event.detail;

  // If the "add to cart" request is successful
  if (requestState.requestType === 'add' && requestState.responseData?.ok) {

    // Add the CSS class to the "body" tag
    document.body.classList.add('js-show-ajax-cart');
    // checkCartQuantityLimits()
  }
  
});

document.addEventListener("liquid-ajax-cart:request-start", function(event) {
  const {requestState} = event.detail;
  console.log(event.detail)
  console.log('request type',requestState.requestType)

});

document.addEventListener("liquid-ajax-cart:queue-end", function() {
  /**
   * cart content weight checker start
   */
  console.log("The current cart state is: ", window.liquidAjaxCart.cart);
  let total_weight_kg = window.liquidAjaxCart.cart.total_weight/1000
  const max_total_weight_kg = 125.0;
  if(total_weight_kg > max_total_weight_kg){
    let observe = setInterval(function(){
      console.log("observing")
      if($('.my-cart__checkout').attr('disabled')!='disabled'){
        $('.my-cart__checkout').attr('disabled',true)
        $('.my-cart__warning-total-weight-container').show()
        clearInterval(observe)
      }
    },500)
  }else{
    $('.my-cart__warning-total-weight-container').hide()
  }
  /**
   * cart content weight checker end
   */

  
  async function appliedGiftCodes(token){
    const productQuery = `
      query cart{
        cart(
          id: "gid://shopify/Cart/${token}"
        ) {
          appliedGiftCards {
            amountUsed {
              amount
            }
            lastCharacters
            balance {
              amount
            }
            id
          }
          cost {
            totalAmount {
              amount
            }
            subtotalAmount {
              amount
            }
            checkoutChargeAmount {
              amount
            }
          }
        }
      }
    `;
    const response = await client.fetch(productQuery,{
        retries: 3,
      }
    );
    console.log(response)
    if (response.ok) {
      const {errors, data, extensions} = await response.json();
      console.log(data)
      console.log(errors)
      console.log(extensions)
      if(data.cart.appliedGiftCards.length > 0){
        const giftCardData = data.cart.cost
        console.log('giftcardata',giftCardData)
        $('.cart-subtotal__savings').html("$"+giftCardData.checkoutChargeAmount.amount)
        $('.my-cart__total-final').html("$"+giftCardData.totalAmount.amount)

      }
    }
  }
  //end giftcode function


  checkCartQuantityLimits()
  // appliedGiftCodes(liquidAjaxCart.cart.token)
});


function checkCartQuantityLimits() {
  
 
  const cart = window.liquidAjaxCart.cart;

  // If the cart is empty -- do nothing, stop the function
  if (cart.item_count === 0 || checkedLimits == true) {
    return;
  }
  checkedLimits=true

  
  const MOQ_10 = 'MOQ-10'
  const MAX_OQ10 = 'MAX-OQ10'
  const MOQ_2 = 'MOQ-2'
  const MAX_OQ2 = 'MAX-OQ2'
  const MXOQ_3 = 'MXOQ-3'
  const MXOQ_5 = 'MXOQ-5'
  const MXOQ_D_1 = 'MXOQ-D-1'
  let rules = [
    MOQ_10,
    MAX_OQ10,
    MOQ_2,
    MAX_OQ2,
    MXOQ_3,
    MXOQ_5,
    MXOQ_D_1
  ]

  //get all items
  //check item tags
  //if exist mark for update
  let quantitySet = []
  let warningTexts = []
  let detectLimits=false
  $(`.my-cart__item__line`).each(function(index){

    let tags = $(this).find('.my-cart__item__tags').attr('data-tags')?.split(',')
    console.log('tags',tags)

    let found = tags.find(t => {
      return rules.some(r => r == t)
    })

    let currentQuantity = parseInt($(`[data-line=${index+1}] .my-cart__item__quantity`).val())

    if(found){
      detectLimits=true
      let text = ''
      let quantity = ''
      switch(found){
        case MOQ_10:
          if(currentQuantity < 10){
            quantity = 10
            text = "Minimum 10 pcs"
          }
          break;
        case MAX_OQ10:
          if(currentQuantity > 10){
            quantity = 10
            text = "Maximum 10 pcs"
          }
          break;
        case MOQ_2:
          if(currentQuantity < 2){
            quantity = 2
            text = "Minimum 2 pcs"
          }
          break;
        case MAX_OQ2:
          if(currentQuantity > 2){
            quantity = 2
            text="Maximum 2 pcs"
          }
          break;
        case MXOQ_3:
          if(currentQuantity > 3){
            quantity = 3
            text = "Maximum 3 pcs"
          }
          break;
        case MXOQ_5:
          if(currentQuantity > 5){
            quantity = 5
            text = "Maximum 5 pcs"
          }
          break;
        case MXOQ_D_1:
          if(currentQuantity > 1){
            quantity = 1
            text = "Maximum 1 pc"
          }
          break;
      }
      quantitySet.push(quantity)
      warningTexts.push(text)
    }
    else{
      //set current quantity if no limit
      quantitySet.push(currentQuantity)
      //set warning blank
      warningTexts.push('')
    }

  })

  console.log('quantitySet',quantitySet)
  console.log('warningTexts',warningTexts)
  if(detectLimits){
    const body = {
      updates: quantitySet
    }
    const options = {
      firstCallback: function(requestState) {},
      lastCallback: function(requestState) {
        $('.my-cart__item__line').each(function(index){
          $(`[data-line=${index+1}] .my-cart__warning-text`).html(warningTexts[index])
        })
        setTimeout(function(){checkedLimits=false},2000)
        
      },
      info: {},
      // whether the request should go to the beginning of the queue rather than to the end
      important: false
    }
    window.liquidAjaxCart.update(body,options)
  }

}
document.addEventListener("liquid-ajax-cart:queue-end", function () {
  const mainProductVariantId = 46909334814887;
  const freebieVariantId = 46946379595943;
  const cart = window.liquidAjaxCart.cart;

  const mainItem = cart.items.find(item => item.variant_id === mainProductVariantId);
  const freebieItem = cart.items.find(item => item.variant_id === freebieVariantId);

  if (!mainItem) {
    if (freebieItem?.key) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: freebieItem.key,
          quantity: 0,
        }),
      }).then(() => {
        console.log('[Freebie Removed] Because main item not in cart');
        window.liquidAjaxCart.update();
      });
    }
    return;
  }

  const mainQty = mainItem.quantity;
  const freebieQty = freebieItem ? freebieItem.quantity : 0;

  if (mainQty !== freebieQty) {
    if (freebieItem?.key) {
      // Change existing line item using line item key
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: freebieItem.key,
          quantity: mainQty,
        }),
      }).then(() => {
        console.log(`[Freebie Synced] Updated quantity to ${mainQty}`);
        window.liquidAjaxCart.update();
      });
    } else {
      // Add freebie for the first time using /cart/add.js with variant ID
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: freebieVariantId,
            quantity: mainQty,
          }]
        }),
      }).then(() => {
        console.log(`[Freebie Synced] Added ${mainQty} to cart`);
        window.liquidAjaxCart.update();
      });
    }
  }
});


